import { Lock, Visibility, VisibilityOff } from 'material-ui-icons';
import Button from 'material-ui/Button';
import Card, { CardActions, CardContent, CardHeader } from 'material-ui/Card';
import { FormControl, FormHelperText } from 'material-ui/Form';
import IconButton from 'material-ui/IconButton';
import Input, { InputAdornment, InputLabel } from 'material-ui/Input';
import { CircularProgress } from 'material-ui/Progress';
import React from 'react';
import { translate } from 'react-i18next';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { getAccountName } from '../Utils/UserFunctions';
import { resetPassword, validatePassword, verifyToken } from './ChangePasswordService';

class ChangePassword extends OLYWebPageComponent {
    constructor(props) {
        super(props);

        this.pageName = 'ChangePassword';
        this.pageTitle = props.t('RECOVER_PASSWORD.CHANGE_PASSWORD');
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/689537084/UI+-+Cambiar+Contrase+a';

        this.state = {
            user: {
                userName: '',
                newPassword: '',
                verifyPassword: ''
            },
            loading: true,
            verify: false,
            failed: false,
            showPassword: false,
            showVerifyPassword: false,
            disableChangeButton: true
        };

        this.accountName = getAccountName().toLowerCase();
    }

    componentDidMount() {
        console.log(this.props.match.params.token);
        verifyToken(this.props.match.params.token)
            .then(response => {
                let user = this.state.user;
                user['userName'] = response.user;
                this.setState({
                    loading: false,
                    verify: true,
                    failed: false,
                    message: '',
                    disableChangeButton: true
                });
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    verify: false,
                    failed: true,
                    disableChangeButton: true,
                    message: this.props.t('RECOVER_PASSWORD.PAGE_NOT_AVAILABLE')
                });
            });
    }

    onChangePassword = () => {
        this.setState({ loading: true, failed: false });
        resetPassword(this.state.user.userName, this.props.match.params.token, this.state.user.newPassword)
            .then(response => {
                this.setState({
                    loading: false,
                    failed: false,
                    verify: false,
                    message: this.props.t('RECOVER_PASSWORD.RECOVER_SUCCESS')
                });
                alert(this.props.t('RECOVER_PASSWORD.RECOVER_SUCCESS'));
                window.setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    failed: true,
                    message: this.props.t('RECOVER_PASSWORD.ERROR_CHANGING_PASSWORD')
                });
            });
    }

    setPassword(value) {
        let user = this.state.user;
        user['newPassword'] = value;
        this.setState({ user });
        this.validatePassword();
    }

    setVerifyPassword(value) {
        let user = this.state.user;
        user['verifyPassword'] = value;
        this.setState({ user });
        this.validatePassword();
    }

    /**
     * Validate password rules.
     * Rules:
     *  ^.*              : Start
     *  (?=.{8,})        : Length. Password must have 8 characters 
     *  (?=.*[a-zA-Z])   : Letters. Password must have at least 1 Capital Letter.
     *  (?=.*\d)         : Digits. Password must have at least 1 digit.
     *  .*$              : End
     *
     */
    validatePassword = () => {

        const validationResult = validatePassword(this.state.user.newPassword,
            this.state.user.verifyPassword);

        this.setState({
            failed: validationResult.failed,
            disableChangeButton: validationResult.failed,
            message: validationResult.message
        });

    }

    fieldGenerator = fieldname => {
        return {
            onChange: event => {
                let user = this.state.user;
                user[fieldname] = event.target.value;
                this.setState({ user });
            },
            value: this.state.user[fieldname]
        };
    };

    render() {
        const { t } = this.props;
        return (
            <div className={'mainbody'}>
                <div className={'loginbox'}>
                    <img
                        src={`assets/${this.accountName}/logo-login.png`}
                        className={'centered'}
                        alt="logo"
                        style={{ marginBottom: '1rem' }}
                    />
                    {!this.state.loading && this.state.verify ?
                        (<Card>
                            <CardHeader
                                title={t('RECOVER_PASSWORD.CHANGE_PASSWORD')}
                                subheader={t('RECOVER_PASSWORD.PLEASE_ENTER_NEW_PASSWORD')}
                            />
                            <CardContent>
                                <FormControl fullWidth error={this.state.failed}>
                                    <InputLabel htmlFor="newPassword">{t('LOGIN.PASSWORD')}</InputLabel>
                                    <Input
                                        id="newPassword"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        startAdornment={<Lock />}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                >
                                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        onChange={event => {
                                            this.setPassword(String(event.target.value));
                                        }}
                                    />
                                </FormControl>
                                <span> </span>
                                <FormControl fullWidth error={this.state.failed}>
                                    <InputLabel htmlFor="verifyPassword">{t('RECOVER_PASSWORD.VERIFY_PASSWORD')}</InputLabel>
                                    <Input
                                        id="verifyPassword"
                                        type={this.state.showVerifyPassword ? 'text' : 'password'}
                                        startAdornment={<Lock />}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => this.setState({ showVerifyPassword: !this.state.showVerifyPassword })}
                                                >
                                                    {this.state.showVerifyPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        onChange={event => {
                                            this.setVerifyPassword(String(event.target.value));
                                        }}
                                    />
                                </FormControl>
                                {this.state.failed ? (
                                    <FormHelperText
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {t(this.state.message)}
                                    </FormHelperText>
                                ) : (
                                    ''
                                )}
                            </CardContent>
                            <CardActions>
                                {this.state.loading ? (
                                    <CircularProgress style={{ margin: 'auto' }} />
                                ) : (
                                    <Button
                                        color="primary"
                                        style={{ width: '100%' }}
                                        onClick={this.onChangePassword}
                                        disabled={this.state.disableChangeButton}
                                    >
                                        {t('RECOVER_PASSWORD.CHANGE_BUTTON').toUpperCase()}
                                    </Button>
                                )}
                            </CardActions>
                        </Card>
                        ) : (
                            <Card>
                                <CardHeader
                                    title={t('RECOVER_PASSWORD.CHANGE_PASSWORD')}
                                    subheader={this.state.failed ?
                                        t('RECOVER_PASSWORD.ERROR_ON_DATA_VALIDATION')
                                        : ''}
                                />
                                <CardContent>
                                    <label>{this.state.message}</label>
                                </CardContent>
                            </Card>
                        )}
                    <Button href="/">
                        {t('RECOVER_PASSWORD.BACK_TO_LOGIN')}
                    </Button>
                </div>
            </div>
        );
    }
}

export default translate('translations')(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js